(() => {
  const SELECTOR = '[data-card-video]';
  const DESKTOP_QUERY = '(min-width: 990px)';

  class CardProductVideo {
    constructor(container) {
      this.container = container;
      this.video = container.querySelector('video');
      if (!this.video) return;

      this.behavior = container.dataset.cardVideoBehavior || 'none';
      this.desktopOnly = container.dataset.cardVideoDesktopOnly === 'true';
      this.mql = window.matchMedia(DESKTOP_QUERY);

      this.onEnter = this.onEnter.bind(this);
      this.onLeave = this.onLeave.bind(this);
      this.onFocus = this.onFocus.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onMediaChange = this.onMediaChange.bind(this);

      this.prepareVideo();
      this.applyBehavior();

      if (this.desktopOnly) {
        this.mql.addEventListener('change', this.onMediaChange);
      }
    }

    prepareVideo() {
      this.video.muted = true;
      this.video.setAttribute('playsinline', '');
      this.video.preload = this.video.preload || 'metadata';
    }

    isActive() {
      return !this.desktopOnly || this.mql.matches;
    }

    applyBehavior() {
      this.detachHover();
      this.video.autoplay = false;
      this.video.pause();

      if (!this.isActive()) return;

      if (this.behavior === 'autoplay') {
        this.video.autoplay = true;
        this.tryPlay();
      } else if (this.behavior === 'hover') {
        this.attachHover();
      }
    }

    tryPlay() {
      const playPromise = this.video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    attachHover() {
      this.container.addEventListener('mouseenter', this.onEnter);
      this.container.addEventListener('mouseleave', this.onLeave);
      this.container.addEventListener('focusin', this.onFocus);
      this.container.addEventListener('focusout', this.onBlur);
    }

    detachHover() {
      this.container.removeEventListener('mouseenter', this.onEnter);
      this.container.removeEventListener('mouseleave', this.onLeave);
      this.container.removeEventListener('focusin', this.onFocus);
      this.container.removeEventListener('focusout', this.onBlur);
    }

    onEnter() {
      this.tryPlay();
    }

    onLeave() {
      this.video.pause();
    }

    onFocus() {
      this.tryPlay();
    }

    onBlur() {
      this.video.pause();
    }

    onMediaChange() {
      this.applyBehavior();
    }
  }

  const init = () => {
    document.querySelectorAll(SELECTOR).forEach((container) => {
      new CardProductVideo(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
